export { default as useLoyaltyBackground } from './use-loyalty-background';
